import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FrontdeskService } from '../../services/frontdesk/frontdesk.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';

@Component({
  selector: 'app-frontdesk-dashboard',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './frontdesk-dashboard.component.html',
  styleUrls: ['./frontdesk-dashboard.component.scss', '../../../common-style/dropdown.scss'],
})
export class FrontdeskDashboardComponent implements OnInit {
  premises = new FormControl<number | 'all'>('all', { nonNullable: true });

  premisesList: any[] = [];
  counts: any = null;
  isLoading: boolean = false;

  constructor(
    private frontdeskService: FrontdeskService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.loadPremises();
    this.loadCounts();
  }

  loadPremises(): void {
    this.frontdeskService.fetchPremises().subscribe({
      next: (res: any) => (this.premisesList = res?.data || []),
      error: (err) => this.toastService.error(err?.error?.message || 'Failed to load premises.'),
    });
  }

  loadCounts(): void {
    this.isLoading = true;
    this.frontdeskService.getDashboardCounts(this.premises.value).subscribe({
      next: (res: any) => {
        this.counts = res?.data || null;
        this.isLoading = false;
      },
      error: (err) => {
        this.counts = null;
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load counts.');
      },
    });
  }
}
